<template>
  <div class="difficultDegree" style="display: block;" ref="gradingResult">
    <div class="difficultDegree__dialog" role="document">
      <div class="difficultDegree__content">
        <div class="difficultDegree__content__closeBtn" @click="closeDialog"></div>
        <div class="difficultDegree__body">
          <div class="difficultDegree__body__content" v-if="degreeResult">
            <div class="recommendTitle">我们为宝贝推荐的课程难度为：</div>
            <div class="recommendClassName">{{ degreeResult.difficulty_name }}</div>
            <div class="btns">
              <span
                class="joinExamBtn"
                ref="joinExam"
                v-if="degreeResult.exam_url"
                @click="joinExam(degreeResult.exam_url)"
              ></span>
              <span
                class="selectClassBtn"
                ref="selectClass"
                @click="selectClass($event)"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'grading-result',
  props: ['backToCourseCenter'],
  data() {
    return {
      degreeResult: null
    }
  },
  created() {
    this.degreeResult = this.$store.state.CourseCenter.difficultDegree.data
  },
  mounted() {
    const XESLog = new this.$XESLog({
      key: 'xeslog-englishGradingResult',
      difficultyId: this.degreeResult.difficulty_id
    })
    XESLog.push({ eventname: 'exposure', target: this.$refs.gradingResult }, this.$route)
  },
  computed: {
    ...mapState({
      userIsLogin: state => state.userIsLogin
    })
  },
  methods: {
    closeDialog(event) {
      this.$store.commit('SET_SHOWGRADINGRESULT', false)
    },
    joinExam(url) {
      const XESLog = new this.$XESLog({
        type: 'xeslog-joinExam',
        clickId: '1.2.37',
        userIsLogin: this.userIsLogin,
        difficulty: this.degreeResult.difficulty_name
      })
      XESLog.push({ eventname: 'click', target: this.$refs.joinExam }, this.$route)
      window.open(url)
    },
    selectClass(event) {
      const XESLog = new this.$XESLog({
        type: 'xeslog-selectClass',
        clickId: '1.2.38',
        difficulty: this.degreeResult.difficulty_name
      })
      XESLog.push({ eventname: 'click', target: this.$refs.selectClass }, this.$route)
      this.$store.commit('SET_SHOWDEGREETIP', true)
      this.$store.commit('SET_SHOWGRADINGRESULT', false)
      let gradeId = this.degreeResult.stu_grade_id || 4
      const { subject = -837 } = this.$route.params
      window.location.href = `https://online.xueersi.com/search?keyword=${this.degreeResult.difficulty_name}&grades=${gradeId}&subjects=${subject}`
      // if (window.location.href.indexOf('course-center') === -1) {
      // this.$router.push({
      //   name: 'course-center',
      //   params: {
      //     courseType: this.backToCourseCenter.coursetype,
      //     grade: this.backToCourseCenter.gradeId,
      //     subject: this.backToCourseCenter.subjectAlias
      //   },
      //   query: {
      //     difficultyId: this.degreeResult.difficulty_id
      //   }
      // })
      // } else {
      //   this.$emit('updataDifficultId', this.degreeResult.difficulty_id, event)
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(difficultDegree) {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  -webkit-overflow-scrolling: touch;
  outline: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba($color: rgb(27, 27, 27), $alpha: 0.7);
  @include e(dialog) {
    width: 941px;
    position: absolute;
    margin: 10px auto;
    left: 0;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
  @include e(content) {
    position: relative;
    outline: 0;
    @include e(closeBtn) {
      position: absolute;
      top: -14px;
      right: 63px;
      width: 61px;
      height: 67px;
      z-index: 1051;
      background: url('./img/closeBtn.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      &:hover {
        background: url('./img/closeBtn-click.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
    }
  }
  @include e(body) {
    // width: 950px;
    width: 894px;
    height: 475px;
    position: relative;
    background: url('./img/cardBackgrouond.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    object-fit: contain;
    overflow: hidden;
    @include e(content) {
      margin: 59px 97px 0px 97px;
      overflow: hidden;
      .recommendTitle {
        margin-left: 50px;
        margin-top: 20px;
        font-size: 31px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(83, 71, 95, 1);
        line-height: 44px;
      }
      .recommendClassName {
        display: flex;
        height: 225px;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 64px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(254, 121, 94, 1);
        line-height: 58px;
        overflow: hidden;
      }
      .btns {
        margin-left: 50px;
        margin-right: 50px;
        display: flex;
        justify-content: space-around;
        .joinExamBtn {
          display: inline-block;
          width: 285px;
          height: 81px;
          margin-right: 31px;
          text-align: center;
          background-image: url('./img/joinExam.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          &:hover {
            background-image: url('./img/joinExam-click.png');
          }
        }
        .selectClassBtn {
          display: inline-block;
          width: 285px;
          height: 81px;
          text-align: center;
          background-image: url('./img/selectClass.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          &:hover {
            background-image: url('./img/selectClass-hover.png');
          }
          &:active {
            background-image: url('./img/selectClass-active.png');
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/GradingResult/index.vue